import { subscribe } from '@/utils'
import { NewPaginationData } from '@/types'

import { Params, Response, Service, DetailParams, DetailResponse } from '.'

const fetch = async (params: Params): Promise<Response> => {
	try {
		const res = await subscribe.get<NewPaginationData<any>>(
			'sales/transaction-history',
			{
				params
			}
		)

		// Normalize transaction-type field (can be transaction-type or transaction_type)
		const normalizedData = res.data.data.map((item: any) => {
			if (item['transaction-type'] && !item.transaction_type) {
				item.transaction_type = item['transaction-type']
			}
			return item
		})

		// Convert new pagination format to old format
		const convertedResponse: Response = {
			status_code: res.data.status_code,
			status: 'success',
			paginator: {
				current_page: res.data.pagination.current_page,
				per_page: res.data.pagination.items_per_page,
				previous_page:
					res.data.pagination.current_page > 1
						? res.data.pagination.current_page - 1
						: 0,
				next_page:
					res.data.pagination.current_page < res.data.pagination.total_pages
						? res.data.pagination.current_page + 1
						: 0,
				total_items: res.data.pagination.total_items,
				total_pages: res.data.pagination.total_pages
			},
			data: normalizedData
		}

		return convertedResponse
	} catch (e) {
		throw e
	}
}

const fetchDetail = async (params: DetailParams): Promise<DetailResponse> => {
	try {
		const queryParams: any = {}
		if (params.partner_code) {
			queryParams.partner_code = params.partner_code
		}

		const res = await subscribe.get<any>(
			`sales/transaction-history/${params.id}`,
			{
				params: queryParams
			}
		)

		// Response structure: { data: { sal_transactions: {...}, orders: [...] } }
		const responseData = res.data.data

		// Transform to match existing structure while preserving orders
		const normalizedData: any = {
			...responseData.sal_transactions,
			orders: responseData.orders || [],
			// Map first order for backward compatibility
			first_order:
				responseData.orders && responseData.orders.length > 0
					? responseData.orders[0]
					: null
		}

		// Normalize transaction-type field if needed
		if (
			normalizedData &&
			normalizedData['transaction-type'] &&
			!normalizedData.transaction_type
		) {
			normalizedData.transaction_type = normalizedData['transaction-type']
		}

		const convertedResponse: DetailResponse = {
			status_code: res.data.status_code,
			status: 'success',
			message: res.data.message || '',
			data: normalizedData
		}

		return convertedResponse
	} catch (e) {
		throw e
	}
}

export const service: Service = {
	fetch,
	fetchDetail
}
